// Copyright (c) 2025 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const AdditionalDetailsDataTypeDomain = t.list(KeyValuePair, 'KeyValuePair');

export const getDefaultState = () => new AdditionalDetailsDataTypeDomain([]);

export default AdditionalDetailsDataTypeDomain;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/additional-data-type-domain.js